(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[521],{

/***/ 9212:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(3447);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 6034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "_": function() { return /* binding */ EmailForm; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _heroicons_react_outline__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9700);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);
/* harmony import */ var react_hot_toast__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4931);
/* harmony import */ var services_analytics_service__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2554);
/* harmony import */ var services_api_service__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1506);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(8680);
/* harmony import */ var _library_Button__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(1317);
/* harmony import */ var _library_Icons__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(4305);
/* harmony import */ var _library_utils_classNames__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(5368);











const BUTTON_TEXT = "Join waitlist";
const EmailForm = (param)=>{
    let { shade  } = param;
    const [loading, setLoading] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false);
    const [form, setForm] = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)({
        email: ""
    });
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    const handleSubmit = async (e)=>{
        e.preventDefault();
        setLoading(true);
        services_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .Analytics.identify */ .cp.identify(form.email, {
            email: form.email
        });
        services_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .Analytics.track */ .cp.track(services_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .EventObject.Form */ .fC.Form, services_analytics_service__WEBPACK_IMPORTED_MODULE_3__/* .EventAction.Submitted */ .AO.Submitted, {
            form: "gpt3-interested",
            email: form.email
        });
        const result = await services_api_service__WEBPACK_IMPORTED_MODULE_4__/* .ApiService.post */ .s.post("/api/gpt3-signup", form, {}, (e, method, url, data, config)=>{
            var ref, ref1;
            const message = e === null || e === void 0 ? void 0 : (ref = e.response) === null || ref === void 0 ? void 0 : (ref1 = ref.data) === null || ref1 === void 0 ? void 0 : ref1.message;
            console.log("Failed to fetch:", e, method, url, data, config);
            if (message) {
                react_hot_toast__WEBPACK_IMPORTED_MODULE_7__/* ["default"].error */ .ZP.error(message);
            }
            setLoading(false);
        });
        if (result.status === 200) {
            setTimeout(()=>{
                router.push(utils_constants__WEBPACK_IMPORTED_MODULE_8__/* .LLM_TYPEFORM */ .iA);
            }, 500);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("form", {
        id: "main-cta",
        onSubmit: handleSubmit,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "flex justify-center gap-12",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "relative grow rounded",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "pointer-events-none absolute inset-y-0 left-0 flex items-center pl-12",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_outline__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                className: "h-24 w-24 text-gray-400",
                                "aria-hidden": "true"
                            })
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", {
                            type: "email",
                            name: "email",
                            id: "email",
                            required: true,
                            className: "form-input block h-[44px] w-full rounded border-[#757DF0] pl-48 pr-[140px] text-14-20 text-black ring-[3px] ring-blue-200 md:h-52 md:pr-0 md:text-16-24",
                            placeholder: "your email",
                            value: form.email,
                            onChange: (e)=>{
                                setForm({
                                    ...form,
                                    email: e.target.value
                                });
                            }
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "absolute inset-y-0 right-0 p-6 md:hidden",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_library_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                type: "submit",
                                styling: "solid",
                                shade: _library_Button__WEBPACK_IMPORTED_MODULE_5__/* .ButtonShade.Blue */ .B.Blue,
                                className: (0,_library_utils_classNames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(shade === "black" && "!bg-black"),
                                size: 32,
                                loading: loading,
                                IconRight: loading ? _library_Icons__WEBPACK_IMPORTED_MODULE_6__/* .LoadingIcon */ .Ho : undefined,
                                children: BUTTON_TEXT
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_library_Button__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    type: "submit",
                    styling: "solid",
                    shade: _library_Button__WEBPACK_IMPORTED_MODULE_5__/* .ButtonShade.Blue */ .B.Blue,
                    className: (0,_library_utils_classNames__WEBPACK_IMPORTED_MODULE_10__/* .classNames */ .A)(shade === "black" && "!bg-black", "hidden md:flex ", loading ? "pl-32" : "px-32"),
                    loading: loading,
                    IconRight: loading ? _library_Icons__WEBPACK_IMPORTED_MODULE_6__/* .LoadingIcon */ .Ho : undefined,
                    size: 52,
                    children: BUTTON_TEXT
                })
            ]
        })
    });
};


/***/ }),

/***/ 5528:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "f": function() { return /* binding */ BackgroundDiagonalRings; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5368);
/* harmony import */ var hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(7921);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(7294);




const BackgroundDiagonalRings = (param)=>{
    let { children , className  } = param;
    const { isMediumWidth , isLargeWidth  } = (0,hooks_useBreakpoints__WEBPACK_IMPORTED_MODULE_1__/* .useBreakpoints */ .k)();
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,_components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)("relative overflow-hidden", className),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: "",
                src: "/assets/lissajous/lissajous-1-rotated-displaced.svg",
                className: " absolute -top-[180px] -left-[170px] w-1/4 select-none"
            }),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                alt: "",
                src: "/assets/lissajous/lissajous-1-rotated-displaced.svg",
                className: " absolute -bottom-[170px] -right-[180px] w-1/4 select-none"
            })
        ]
    });
};


/***/ }),

/***/ 2010:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "t": function() { return /* binding */ CTASection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);
/* harmony import */ var _components_foundation_EmailForm__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(6034);
/* harmony import */ var _components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5368);
/* harmony import */ var _BackgroundDiagonalRings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5528);




const CTASection = (param)=>{
    let { className  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_BackgroundDiagonalRings__WEBPACK_IMPORTED_MODULE_2__/* .BackgroundDiagonalRings */ .f, {
        className: className,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (0,_components_library_utils_classNames__WEBPACK_IMPORTED_MODULE_3__/* .classNames */ .A)("container-xl mx-auto flex flex-col gap-4 py-48 text-center md:gap-12 md:py-160 md:pl-64 "),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    className: "text-16-24 text-gray-700 dark:text-white md:font-display md:text-24-32",
                    children: "Get started today"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h4", {
                    className: "mb-24 font-display text-24-28 font-bold tracking-wide text-black dark:text-white md:mb-40 md:text-[56px] md:font-normal md:leading-[56px]",
                    children: "Start building custom AI in minutes"
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "mx-auto flex",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_foundation_EmailForm__WEBPACK_IMPORTED_MODULE_1__/* .EmailForm */ ._, {})
                })
            ]
        })
    });
};


/***/ }),

/***/ 9422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H": function() { return /* binding */ PageTitleAndHeroText; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

const PageTitleAndHeroText = (param)=>{
    let { title , text  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-14-16 text-gray-600 sm:text-18-28",
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "mt-8 max-w-[640px] font-display text-32-40 text-gray-900 sm:mt-12 sm:text-[56px] sm:leading-[56px]",
                children: text
            })
        ]
    });
};


/***/ }),

/***/ 3447:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./components/platform/Layout.tsx + 2 modules
var Layout = __webpack_require__(8372);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(5675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
;// CONCATENATED MODULE: ./public/assets/documentary/raza-jordan-whiteboard.jpeg
/* harmony default export */ var raza_jordan_whiteboard = ({"src":"/_next/static/media/raza-jordan-whiteboard.bc372c29.jpeg","height":3024,"width":4032,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAfEAABAwMFAAAAAAAAAAAAAAABAAIDBAURBhITImH/xAAVAQEBAAAAAAAAAAAAAAAAAAACA//EABYRAQEBAAAAAAAAAAAAAAAAAAEAAv/aAAwDAQACEQMRAD8Ait1ZcYm0UcXEKeRzurowTtJwRkjxERSMk1b/2Q==","blurWidth":8,"blurHeight":6});
// EXTERNAL MODULE: ./components/platform/PageTitleAndHeroText.tsx
var PageTitleAndHeroText = __webpack_require__(9422);
;// CONCATENATED MODULE: ./components/platform/AboutUsHero.tsx




const BUILDING_THE_FUTURE = "\nWe're building the future in which AI does not replace humans\nbut gives people the tools to achieve things that today are\nrestricted to a tiny group of people with specialist expertise.\n";
const AboutUsHero = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: " mt-32 flex flex-col gap-x-48 gap-y-48 sm:mt-[88px] lg:mx-120 lg:flex-row lg:items-end lg:justify-between ",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "max-w-[640px] grow",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PageTitleAndHeroText/* PageTitleAndHeroText */.H, {
                                title: "Our Mission",
                                text: "Make programming computers as natural as teaching a colleague"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "hidden max-w-[32ch] shrink sm:block",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-14-24 text-gray-800",
                                children: BUILDING_THE_FUTURE
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "mt-32 mb-32 sm:mb-40 sm:mt-80",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "container-xl relative h-[256px] items-center overflow-y-hidden sm:h-320 md:h-480 lg:h-[640px]",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "grain inset-0 opacity-90"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                            priority: true,
                            className: "brightness-125 contrast-[1.10] grayscale",
                            src: raza_jordan_whiteboard,
                            alt: "",
                            fill: true,
                            sizes: "100vw",
                            style: {
                                objectFit: "cover"
                            }
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-xl mb-48",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "block max-w-[32ch] sm:hidden",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-14-24 text-gray-800",
                        children: BUILDING_THE_FUTURE
                    })
                })
            })
        ]
    });
/* harmony default export */ var platform_AboutUsHero = (AboutUsHero);

;// CONCATENATED MODULE: ./public/assets/headshots/peter.png
/* harmony default export */ var peter = ({"src":"/_next/static/media/peter.ce56fe91.png","height":346,"width":346,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAbFBMVEX////+/kSWlv9qamHe3v/9/Yulpf+Kiv7//5z//xm3t5aysm19fev9/fz9/dP8/P5dXTvq6hk5OQ3W1h63t/LOzn1QUGJeXuw3N/2oqE99ff///2OBgalcXP+JiUnn52YbG4EfH3d6esR3d3DAw4GLAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVQImR3GRxKAIBAAwQHEBcGcc/r/H62yT433vm6VdRSurxpjLZRplw1BQS5axnkFUpEYHJDIsp1/dDRvBsm0P8d9fV3RAvxruGfwAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/headshots/raza.png
/* harmony default export */ var raza = ({"src":"/_next/static/media/raza.ee582edb.png","height":346,"width":346,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAb1BMVEX///9hYf4SEv7//5b//9L39/+5uf9zc/0CAv46Ov+Tk/8MDBl8fEv///Pf36aenlXV1f+wsCAAANLp6R///3U/P3Dm5v9DQ6lmZv7p6Xz//6tkZG+lpbXHxz47OxXFxaKcnLNKSqQ5OQFwcKKcnP/rAXPXAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVQImRXGRRLAMAwEsA3aTlJmxv+/sVOdBGR5UTWtAZxw3U0G8JqInxkohehKFkBQ73r86Smcm4Xzo1C6FyhmPewxfmqRAyLVCqHTAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/headshots/jordan.png
/* harmony default export */ var jordan = ({"src":"/_next/static/media/jordan.4e3d0213.png","height":346,"width":346,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEX///+6uv+dnf7Q0P+wsP///2H09P+Dg/7//4aSkv9PT/T//xmHh5JqauxnZ/4/P7fY2KpFRYqUlLqmpv3u7m3Kymv//7WCgraxsVfn5zAyMot8fDn//z3Pzzbh4RW+vg81NRuIiEn7+//AR4guAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQklEQVQImQXBhQHAIBAAscP6SN1d2H/IJsC8PXdKZFTc38sBMZjjc1CEwS7rCYWyWiZHxmjpRw/ZSlV6Tw61NF3rf3ebAyxPwIYeAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/headshots/david.png
/* harmony default export */ var david = ({"src":"/_next/static/media/david.efa3206e.png","height":346,"width":346,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAZlBMVEX////9/f/q6v7Jyf56ev+YmP/+/n+Fhf///7L29v6rq6f//5jJyYZGRv5gYP6Dg9qCgkzv75GKiqd/f3Cvr/97e+RtbfWXl/EAAP+1tXmPj+D//2QJCUqiooYAAKk6OpCUlFhDQ2YKqJguAAAACXBIWXMAAAsTAAALEwEAmpwYAAAARUlEQVQImRXGRxaAIAwFwB8ISUDsvev9L+lzVgNC3O7TDIRquY4sQCx5fp8diByGaRWAgoYxFyB41iR/nNZ9a4Dz2jXJPm7iArn3orQNAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/headshots/emine.png
/* harmony default export */ var emine = ({"src":"/_next/static/media/emine.f0c095d0.png","height":346,"width":346,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAb1BMVEX//////2ahof45Of7//6CIiPr//3SVlf59ff/f3////4FLS/b4+P/q6v/09HAUFErv7/+pqXIlJf74+AUTExr//zSjowA2NgCxsdxra8Dd3QB5eQYKCm7///V+fpzHx7haWqB3d9gUFKTGxqlzc6Je+kd/AAAACXBIWXMAAAsTAAALEwEAmpwYAAAARklEQVQImSXGRwKAIAwEwAUCCaBi713//0YPzmnguqZfZkXANq3tUASgrPWYKgXkhjnuDsiENR8BgLfC5P5cD8GLifa9zw90JwMa9lY9+wAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
;// CONCATENATED MODULE: ./public/assets/headshots/harry.png
/* harmony default export */ var harry = ({"src":"/_next/static/media/harry.e675800e.png","height":346,"width":346,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAaVBMVEX///8VFf/7+xn//2jh4f9paf/u7v///wtubv+7u/qQkP9GRgnb2/7+/rVISP2QkBf19ZCkpP8+PrZnZxC5uRL//z+amrvk5AU8PEOhoQD//9f//3XCwt8DA8X//zadnf9jY5b///elpaeoODCmAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVQImQXBhQGAMADAsM4dd4f/jyQB5aR0bgSauh9cAWKX0ryDrfy0rBfoNufwKcCGoN8C2vvbHxtGCBOfM/xe/QLj4tZsewAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./components/library/Button.tsx + 1 modules
var Button = __webpack_require__(1317);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(8680);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(7294);
;// CONCATENATED MODULE: ./node_modules/@heroicons/react/outline/esm/ExternalLinkIcon.js


function ExternalLinkIcon(props, svgRef) {
  return /*#__PURE__*/react.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    strokeWidth: 2,
    stroke: "currentColor",
    "aria-hidden": "true",
    ref: svgRef
  }, props), /*#__PURE__*/react.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
  }));
}

const ForwardRef = react.forwardRef(ExternalLinkIcon);
/* harmony default export */ var esm_ExternalLinkIcon = (ForwardRef);
;// CONCATENATED MODULE: ./components/platform/MeetTheTeam.tsx











const MeetTheTeam = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "bg-black",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "container-xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "grid grid-cols-1 gap-x-40 gap-y-24 pb-40 sm:grid-cols-2 md:grid-cols-3 md:gap-y-80 md:gap-x-40 md:px-120 md:pt-120 md:pb-160",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "mb-16 mt-48 font-display text-24-32 font-bold text-gray-400",
                                children: "Meet the team"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: " mb-12 text-14-22 text-gray-400",
                                children: "Our team have previously worked on some of the largest AI projects at Google, Microsoft and Amazon. We're backed by some of the world's top investors including Index Ventures and Y Combinator"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                className: "mt-32 bg-white",
                                IconRight: esm_ExternalLinkIcon,
                                href: constants/* CAREERS_LINK */.Fg,
                                styling: "solid",
                                children: "View open positions"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "hidden py-48 sm:block md:col-span-2"
                    }),
                    teamMembers.map((teamMember)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(TeamMember, {
                            ...teamMember
                        }, teamMember.name))
                ]
            })
        })
    });
};
/* harmony default export */ var platform_MeetTheTeam = (MeetTheTeam);
const teamMembers = [
    {
        name: "Raza Habib",
        title: "Cofounder & CEO",
        description: "Ex-MonolithAI and Google. ML PhD @ UCL and MSc in Physics @ Cambridge.",
        imageSrc: raza
    },
    {
        name: "Jordan Burgess",
        title: "Cofounder",
        description: "Previously at Amazon Alexa Research. ML MPhil @ Cambridge and CS @ MIT.",
        imageSrc: jordan
    },
    {
        name: "Peter Hayes",
        title: "Cofounder",
        description: "Previously cofounder @ Certua. ML PhD @ UCL.",
        imageSrc: peter
    },
    {
        name: "David Barber",
        title: "Cofounder & Research",
        description: "Director of UCL's AI Center and previously cofounder @ Re:infer.",
        imageSrc: david
    },
    {
        name: "Emine Yilmaz",
        title: "Cofounder & Research",
        description: "Professor at UCL, Turing Fellow, Amazon Scholar.",
        imageSrc: emine
    },
    {
        name: "Harry Xie",
        title: "Product",
        description: "Previously worked on conversational AI at Chai. MSc in Physics @ Imperial.",
        imageSrc: harry
    }
];
const TeamMember = (param)=>{
    let { name , title , description , imageSrc  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "flex flex-row gap-x-24 sm:flex-col",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "block aspect-square min-h-[96px]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: imageSrc,
                    alt: "Portrait of ".concat(name),
                    sizes: "100vw",
                    style: {
                        width: "100%",
                        height: "auto"
                    }
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "sm:w-240",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-14-16 font-bold text-white sm:mt-24 sm:text-16-24",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "mt-6 text-12-14 text-gray-600 sm:mt-8 sm:text-14-16",
                        children: title
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "text-12-24 sm:mt-14 mt-8 w-200 text-gray-400 sm:text-14-22",
                        children: description
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./public/assets/documentary/peter-tom-whiteboard.jpeg
/* harmony default export */ var peter_tom_whiteboard = ({"src":"/_next/static/media/peter-tom-whiteboard.d80b29fa.jpeg","height":3024,"width":4032,"blurDataURL":"data:image/jpeg;base64,/9j/2wBDAAoHBwgHBgoICAgLCgoLDhgQDg0NDh0VFhEYIx8lJCIfIiEmKzcvJik0KSEiMEExNDk7Pj4+JS5ESUM8SDc9Pjv/2wBDAQoLCw4NDhwQEBw7KCIoOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozv/wAARCAAGAAgDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAX/xAAeEAABBAEFAAAAAAAAAAAAAAADAAECBBEGEiFRof/EABQBAQAAAAAAAAAAAAAAAAAAAAH/xAAYEQADAQEAAAAAAAAAAAAAAAAAAQIRMf/aAAwDAQACEQMRAD8Aq6jMcFWwURYkarCT7TBhJst1xn1ERMRNdB01mH//2Q==","blurWidth":8,"blurHeight":6});
;// CONCATENATED MODULE: ./components/platform/JoinUsSection.tsx






const JoinUsSection = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "py-48 sm:py-40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "container-xl",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "grid items-center gap-x-48 md:grid-cols-2 md:pl-120",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "mb-48 md:mb-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mb-12 text-14-24 text-gray-600 sm:text-18-28",
                                    children: "Join us"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "max-w-[291px] font-display text-24-32 text-gray-900 sm:max-w-[469px] sm:text-[56px] sm:leading-[56px]",
                                    children: "Help us build the world's most collaborative AI"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "mt-32 text-14-22 text-gray-800 sm:max-w-[346px] sm:text-14-24",
                                    children: "We believe that the reason we'll succeed is because we're committed to learning and growing as quickly as possible. We know there's lots we don't know. What we're doing is fundamentally new and will require overcoming many hurdles. This excites us. If this excites you, join us."
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                    className: "mt-32",
                                    IconRight: esm_ExternalLinkIcon,
                                    href: constants/* CAREERS_LINK */.Fg,
                                    children: "View open positions"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "relative hidden min-h-[240px] w-full md:block md:aspect-square",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteboardImage, {})
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "relative min-h-[240px] md:hidden",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhiteboardImage, {})
            })
        ]
    });
const WhiteboardImage = ()=>/*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
        className: "-scale-x-100 contrast-125 grayscale",
        src: peter_tom_whiteboard,
        alt: "",
        fill: true,
        sizes: "100vw",
        style: {
            objectFit: "cover",
            objectPosition: "50% 25%"
        }
    });
/* harmony default export */ var platform_JoinUsSection = (JoinUsSection);

// EXTERNAL MODULE: ./components/platform/CTASection.tsx
var CTASection = __webpack_require__(2010);
;// CONCATENATED MODULE: ./pages/about.tsx






const About = ()=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
        className: "",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(platform_AboutUsHero, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(platform_MeetTheTeam, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(platform_JoinUsSection, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(CTASection/* CTASection */.t, {
                className: "bg-gray-100"
            })
        ]
    });
About.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        title: "Humanloop – About us",
        children: page
    });
};
/* harmony default export */ var about = (About);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [664,764,669,787,675,591,372,774,888,179], function() { return __webpack_exec__(9212); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);